import { AppLanguage, IUfinetSelectOption } from 'ufinet-web-functions'

export class ReportOrigin {
	reportOriginId: string
	nameEs: string
	nameEn: string
	namePt: string

	constructor(id: string, nameEs: string, nameEn: string, namePt: string) {
		this.reportOriginId = id
		this.nameEs = nameEs
		this.nameEn = nameEn
		this.namePt = namePt
	}

	static mapReportOriginToSelectOption(self: ReportOrigin, language: AppLanguage): IUfinetSelectOption {
		return {
			label: language === 'es' ? self.nameEs : language === 'en' ? self.nameEn : self.namePt,
			value: self.reportOriginId,
		}
	}
}
